import { enUS } from './en';
import { zhCN } from './zh_cn';

export const sampleResources = {
  en: enUS,
  zh: zhCN
};

